import { Component } from "@angular/core";
import { ToastService } from "../../services/toast.service";

@Component({
  standalone: false,
  selector: "ngbd-toast-global",
  templateUrl: "./toast-global.component.html",
})
export class NgbdToastGlobal {
  constructor(public toastService: ToastService) {}

  showStandard() {
    const options = {
      classname: "bg-info text-light",
      delay: 3000,
    };
    this.toastService.show("I am a standard toast", options);
  }

  showSuccess() {
    const options = {
      classname: "bg-success text-light",
      delay: 10000,
    };
    this.toastService.show("I am a success toast", options);
  }

  showDanger(dangerTpl) {
    const options = {
      classname: "bg-danger text-light",
      delay: 15000,
    };
    this.toastService.show(dangerTpl, options);
  }
}
